import styled from '@emotion/styled'
import { Colors } from "../../../../../colors";
import { mediaQueryMobileLimit } from '../../../../../utils/constants';

export const ReservationSummaryStyled = {
  Container: styled.div<any>`
    background-color: ${Colors.LightGrey};
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 325px;
    @media (min-width: ${mediaQueryMobileLimit}px) {
      min-width: 500px;
      min-height: ${(props: any) => props.minHeight};
    }
  `,
  ContainerCloseIcon: styled.div<any>`
    display: flex; 
    justify-content: flex-end;
    width: 100%
  `,
  ContainerContent: styled.div<any>`
    margin-bottom: 20px
  `,
  Title: styled.p<any>`
    font-family: EncodeSans-Medium;
    margin: 23px 0 23px 0;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  `,
  SubTitle: styled.p<any>`
    font-family: EncodeSans-Medium;
    font-size:16px;
    margin-bottom: 38px;
    text-align: center;
  `,
  FieldName: styled.p<any>`
    font-family: EncodeSans-Medium;
    padding: 5px 5px 5px 0px;
    font-size: 14px;
  `,
  FieldNameContainer: styled.div<any>`
     display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin:10px;
    

  `,
  ContainerEvents: styled.div<any>`
    height: ${(props: any) => (props.reservations.length >= 10 ? '200px' : 'auto')};
    overflow-y: auto; 
    margin-bottom: 10px;
  `,
  ContainerNotes: styled.div<any>`
    height: 100px; 
    overflow-y: auto
  `,
  Event: styled.li<any>`
    padding: 5px 5px 5px 0px;
    font-family: EncodeSans-Regular;
  `,
};


export const sxListReservationSummary = {
  containerButton: { display: 'flex', justifyContent: 'space-between' },
  tableCell: {
    fontFamily: 'EncodeSans-Medium',
    padding: '0px 16px',
    fontSize: '12px',
    fontWeight: '600',
    textAlign: 'start',
    paddingBottom: '20px',
    border: 'none',
  },
  containerButtonLeft: { width: { xs: '110px', sm: '130px', md: '178px' } },
  containerButtonRight: { width: { xs: '130px', sm: '150px', md: '250px' } }
};
